import React from 'react';

export const pageMeta = {
  "name": "JavaScript Objects",
  "link": "/javascript/references/objects"
};

export default function JavascriptReferencesObjects() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JavaScript Objects</h2>
      <p>Route: /javascript/references/objects</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
